import { render, staticRenderFns } from "./AdminPanelDasboardCoupon.vue?vue&type=template&id=36ca26e6"
import script from "./AdminPanelDasboardCoupon.vue?vue&type=script&lang=js"
export * from "./AdminPanelDasboardCoupon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports